import React from "react";
import PageHero from "../components/PageHero";
import TrustIntro from "../components/TrustIntro";
import Stats from "../components/Stats";
import WhyProspera from "../components/WhyProspera";
import HowWeWork from "../components/HowWeWork";
import Testimonials from "../components/Testimonials";
import CTABanner from "../components/CTABanner";
import { IMAGES } from "../config/siteConfig";

export default function About() {
  return (
    <>
      <PageHero
        label="About Us"
        title="A recruitment partner built on"
        highlight="trust and results."
        subtitle="Prospera Staffing is a Dubai-based workforce solutions firm helping organizations across the GCC discover, attract, and retain the people who move business forward."
        image={IMAGES.trust}
      />
      <TrustIntro />
      <Stats />
      <WhyProspera />
      <HowWeWork />
      <Testimonials />
      <CTABanner />
    </>
  );
}
